/* strap-finder fail-open fix deployed 2026-07-25 — see repo strap-finder-outage-2026-07-25 */
let globalIndex = 0;  // Declare globalIndex outside
let globalIndexCount = 0;
let globalDisplayedCount = 0;

// Custom loading overlay for initial load
const showInitialLoadingOverlay = (isOnload = false) => {
    if (isOnload) {
        return;
    }
    const loadingHtml = `<div class="jsc-page-loading">
        <div class="jsc-spinner-container">
            <div class="jsc-spinner"></div>
            <div class="jsc-loading-text">Strap Finder is loading.</div>
        </div>
    </div>`;
    $('body').prepend(loadingHtml);
    
    // Prevent scrolling when overlay is shown
    $('body').css('overflow', 'hidden');
};

// Video loading overlay for filter changes
const showVideoLoadingOverlay = () => {
    const isMobile = window.innerWidth <= 480;
    
    // Get video URLs from the strap finder container data attributes
    const strapFinderContainer = document.querySelector('.strap-finder-only');
    let mobileVideoUrl = 'https://cdn.shopify.com/videos/c/o/v/3c3b5ae584fe4d5e92b27c71f76273a0.mp4'; // fallback
    let desktopVideoUrl = 'https://cdn.shopify.com/videos/c/o/v/5bd28a6e9f034ca5b7598e9a14db9a6f.mp4'; // fallback
    
    if (strapFinderContainer) {
        const mobileUrl = strapFinderContainer.getAttribute('mobile-video-url');
        const desktopUrl = strapFinderContainer.getAttribute('desktop-video-url');
        
        if (mobileUrl) mobileVideoUrl = mobileUrl;
        if (desktopUrl) desktopVideoUrl = desktopUrl;
    }
    
    const videoUrl = isMobile ? mobileVideoUrl : desktopVideoUrl;
    
    // Calculate actual header height - only target shopify-section-group-header-group
    const header = document.querySelector('theme-header');
    
    const headerHeight = header ? header.offsetHeight : (isMobile ? 60 : 80);
    
    const loadingHtml = `<div class="jsc-video-page-loading" style="top: ${headerHeight}px; height: calc(100vh - ${headerHeight}px);">
        <video class="jsc-loading-video" autoplay loop muted playsinline>
            <source src="${videoUrl}" type="video/mp4">
        </video>
    </div>`;
    $('body').prepend(loadingHtml);
    
    // Prevent scrolling when overlay is shown
    $('body').css('overflow', 'hidden');
};

const hideVideoLoadingOverlay = () => {
   $('.jsc-video-page-loading').remove();
   $('.jsc-page-loading').remove();
   
   // Restore scrolling when overlay is hidden
   $('body').css('overflow', 'auto');
};

$(function () {
    // Don't show video loading overlay if on strap finder page (without query parameters)
    var sf_page_handle = $('.jsc-watch-finder').attr('sf-page');
    var isExactStrapFinderPage = window.location.pathname == `/pages/${sf_page_handle}` && !window.location.search;
    if (!isExactStrapFinderPage) {
        showVideoLoadingOverlay();
    }
    fetchWatchDb().then(() => {
        if (!cachedWatchDb) {
            // console.error("Error: Watch database not loaded.");
            return;
        }
        // The watch DB is loaded lazily per brand (see sfLoadBrand in
        // jsc-script-watch-finder-drawer.js): fetchWatchDb() only returns the brand
        // index, so cachedWatchDb is still empty at this point. Load the brand named
        // in the URL first, otherwise onloadFilterData() always misses.
        var brandMatch = window.location.search.match(/brand=([^&?]+)/);
        var urlBrand = '';
        if (brandMatch) {
            try { urlBrand = decodeURIComponent(brandMatch[1]); }
            catch (e) { urlBrand = brandMatch[1]; }
        }
        if (urlBrand && typeof sfLoadBrand === 'function') {
            sfLoadBrand(urlBrand).always(function () { onLoadFunctionStrapInit(); });
        } else {
            onLoadFunctionStrapInit();
        }
    });
});

$(window).on('resize', function() {
    // Only apply resize handling on desktop (width > 1024px)
    if ($(window).width() > 1024) {
        updateStrapOverlay();
    }
});
  
onLoadFunctionStrapInit = () => {
    hideSectionBeforeFlickityLoaded();

    const decodePlus = (s) => (s || '').replace(/\+/g, ' ');
    const safeDecode = (s) => {
        try { return decodeURIComponent(decodePlus(s)); }
        catch { return decodePlus(s); }
    };

    // ---- Parse query string manually ----
    const originalQS = window.location.search.slice(1).replace(/\?filter\./g, '&filter.');
    const parts = originalQS.split('&');

    let nBrand = '';
    let nModel = '';
    let nYear = '';
    let i = 0;

    while (i < parts.length) {
        let part = parts[i];
        if (!part) { i++; continue; }

        const [key, ...rest] = part.split('=');
        let value = rest.join('='); // in case '=' appears inside value

        if (key === 'brand') {
            nBrand = value || '';
            // Lookahead: stitch next parts if they don't contain '=' (like '&S%C3%B6hne')
            let j = i + 1;
            while (j < parts.length && !parts[j].includes('=')) {
                nBrand += '&' + parts[j];
                j++;
            }
            i = j - 1; // skip stitched parts
        } else if (key === 'collection') {
            nModel = value || '';
        } else if (key === 'reference') {
            nYear = value || '';
        }
        i++;
    }

    nBrand = safeDecode(nBrand).replace(/\s{2,}/g, ' ').trim();
    nModel = safeDecode(nModel).replace(/\s{2,}/g, ' ').trim();
    nYear  = safeDecode(nYear).replace(/\s{2,}/g, ' ').trim();

    // console.log('🔍 Parsed URL Parameters:', { brand: nBrand, collection: nModel, reference: nYear });

    // Remove announcement bar if on strap-finder page with brand parameter
    if (window.location.pathname.includes('/pages/strap-finder') && nBrand) {
        $('.announcement-bar-section').remove();
    }

    onloadFilterData(nBrand, nModel, nYear);
};


onloadFilterData = (nBrand, nModel, nYear) => {
    const filteredData = cachedWatchDb.filter(item =>
        item.status === 1 &&
        String(item.brand).replace(/\s+/g, '') === nBrand &&
        String(item.collection).replace(/\s+/g, '') === nModel &&
        String(item.reference).replace(/\s+/g, '') === nYear
    );

    if (!filteredData.length) {
        // console.log('No matching watch found.');
        //strap finder url to pre open the strap drawer
        // Reveal the page on EVERY template, not just /pages/<sf-page>. This block
        // used to be gated on the strap finder page, so a miss on any other template
        // (e.g. the CTS collection pages) left every section hidden by
        // hideSectionBeforeFlickityLoaded() and the page rendered blank.
        $('.shopify-section').not('.shopify-section-group-header-group, .shopify-section-group-footer-group, [id*="strap_only"]').css('opacity', '1');
        $('.shopify-section').not('.shopify-section-group-header-group, .shopify-section-group-footer-group, [id*="strap_only"]').css('visibility', 'visible');
        // hideSectionBeforeFlickityLoaded() reserved 2000px for the strap finder
        // module; release it so an unused module does not leave a blank gap.
        $('.section-spacing.strap-finder-only').css('height', 'auto');
        hideVideoLoadingOverlay();
        return; // Exit early - no watch data to 
    }


    onloadAppendReturnform();
    const watchDetails = filteredData[0];

    const {
        brand = 'N/A',
        collection: model = 'N/A',
        model: col_model = 'N/A',
        reference = 'N/A',
        caseDiameter = 'N/A',
        lugWidth = 'N/A',
        actualLugWidth = 'N/A',
        watchHeadImage: watchFace = 'N/A',
        watchImage: yearImage = 'N/A',
        recommendedCollection = 'N/A',
        integratedStraps: integratedCollection = 'N/A',
        customPageUrl = '',
        sfTopMargin: sfTop = '0',
        sfBottomMargin: sfBottom = '0',
        article1 = '',
        article2 = '',
        article3 = '',
        brandSpecificCollection = 'N/A',
        ['case &HardwareColour']: buckleColor = 'N/A',
        watchCategory: rawWatchCategory = ''
    } = watchDetails;

    const watchCategory = rawWatchCategory.toLowerCase();
    const article_urls = [article1, article2, article3].filter(Boolean).join(', ');

    $('.strap-finder-only')
        .attr({
            'watch-brand': brand,
            'watch-model': model,
            'watch-reference': reference,
            'watch-face': watchFace,
            'sfTop_margin': sfTop,
            'sfBottom_margin': sfBottom,
            'watch-lugwidth': lugWidth,
            'watch-actualLugWidth': actualLugWidth,
            'custom-page-url': customPageUrl,
            'watch-recommended-collection': recommendedCollection,
            'watch-integrated-collection': integratedCollection,
            'buckle-color': buckleColor,
            'brand-specific': brandSpecificCollection,
            'watch-category': watchCategory
        });

    onloadSetHeaderInfo(brand, model, col_model, reference, lugWidth);
    showTooltipDesc(watchCategory);

    const sfPageType = $('.strap-finder-only').attr('sf-page-type');

    // Dropdown filters
    const saved_collection_type = sessionStorage.getItem('selectedFilterType');
    $('custom-select-collection-filter ul').each(function () {
        const $ul = $(this);
        $ul.find('.custom-select__option').each(function () {
            const filterAttr = $(this).attr('filter-category');
            if (!filterAttr) return;
            const categories = filterAttr.split(',').map(c => $.trim(c.toLowerCase()));
            if (!categories.includes(watchCategory)) $(this).remove();
        });

        const $firstLi = $ul.find('.custom-select__option').first();
        if ($firstLi.length) {
            if (saved_collection_type) {
                $ul.closest('.custom-select').find('.custom-select--text').text(saved_collection_type);
                $ul.find('.custom-select__option').each(function() {
                    if ($(this).text().trim() === saved_collection_type) {
                        $(this).addClass('active');
                        return false; 
                    }
                });
            }else{
                $firstLi.addClass('active');
                const text = $firstLi.text().trim();
                $ul.closest('.custom-select').find('.custom-select--text').text(text);
            }
            
        }
    });

    $('custom-select-material-filter .custom-select--list').each(function () {
        const $list = $(this);
        const filterAttr = $list.attr('filter-category');
        if (!filterAttr) return;
        const categories = filterAttr.split(',').map(c => $.trim(c.toLowerCase()));
        if (!categories.includes(watchCategory)) $list.remove();
    });

    const saved_material_filter= sessionStorage.getItem('selectedStrapMaterial');
    $('custom-select-material-filter').each(function () {
        const $container = $(this);
        let $firstList;

        if (saved_collection_type) {
            $firstList = $container.find(`.custom-select--list[filter-option-parent='${saved_collection_type}']`);
        }else{
            $firstList = $container.find('.custom-select--list').first();
        }
        if ($firstList.length) {
            if (saved_material_filter){
                $firstList.addClass('active');
                const $firstLi = $firstList.find(`ul li[filter-material='${saved_material_filter}']`).addClass('active');
                $container.find('.custom-select--text').text($firstLi.text().trim());  
            }else{
                $firstList.addClass('active');
                const $firstLi = $firstList.find('ul li').first().addClass('active');
                $container.find('.custom-select--text').text($firstLi.text().trim());  
            }
        }
    });

    // Initialize color filter
    const saved_colour_filter = sessionStorage.getItem('selectedStrapColour');
    $('custom-select-colour-filter').each(function () {
        const $container = $(this);
        const $firstLi = $container.find('ul li').first();
        
        if (saved_colour_filter) {
            // Parse savedStrapColour format: "displayText,colorValue"
            const colourParts = saved_colour_filter.split(',');
            const savedDisplayText = colourParts[0];
            const savedColourValue = colourParts[1];
            
            const $selectedLi = $container.find(`ul li[filter-colour='${savedColourValue}']`);
            if ($selectedLi.length) {
                $selectedLi.addClass('active');
                const colourDot = $selectedLi.find('.colour-dot');
                $container.find('.custom-select--text').html(
                    `<span class="colour-dot-button" style="background-color: ${colourDot.css('background-color')}; width: 12px; height: 12px; border-radius: 50%; display: inline-block; margin-right: 8px;"></span>${savedDisplayText}`
                );
            } else {
                // Fallback to first option
                $firstLi.addClass('active');
                const displayText = $firstLi.attr('filter-colour-display');
                const colourDot = $firstLi.find('.colour-dot');
                $container.find('.custom-select--text').html(
                    `<span class="colour-dot-button" style="background-color: ${colourDot.css('background-color')}; width: 12px; height: 12px; border-radius: 50%; display: inline-block; margin-right: 8px;"></span>${displayText}`
                );
            }
        } else {
            // Default to first option
            $firstLi.addClass('active');
            const displayText = $firstLi.attr('filter-colour-display');
            const colourDot = $firstLi.find('.colour-dot');
            $container.find('.custom-select--text').html(
                `<span class="colour-dot-button" style="background-color: ${colourDot.css('background-color')}; width: 12px; height: 12px; border-radius: 50%; display: inline-block; margin-right: 8px;"></span>${displayText}`
            );
        }
    });

    if (sfPageType === 'brand') {
        if (brandSpecificCollection) {
            $('.strap-finder-only').show();
            const brand_specific_col_handle = new URL(
                brandSpecificCollection,
                window.location.origin
            ).pathname.split('/').pop();
            if (typeof loadBrandSpecificStraps === 'function') {
                loadBrandSpecificStraps(brand_specific_col_handle, true);

            } 
        }else{
            $('.strap-finder-only').hide();
            // console.log('dddd',$('.strap-finder-only'));
        }
    }else{
    
        if ($(window).width() < 480) {
            $('#strap-filter-list.desktop-only').remove();
        } else {
            $('#strap-filter-list.mobile-only').remove();
        }

        if (watchCategory === 'no strap') {
            $('.strap-finder-only-no-straps').show();
            hideVideoLoadingOverlay();
            onloadSetHeaderInfoNoStrap(brand, model, reference, yearImage);
            showSectionAfterFlickityLoaded();
        }else{
            $('.strap-finder-only').show();
            updateFilterProductCount();
            updateFilterColourProductCount();
        }
    }


    const getHandle = (url) => {
        try {
            return new URL(url).pathname.split("/").pop();
          } catch {
            return '';
          }
    };
    const showTab = (type, isActive = false) => {
        const $tab = $(`custom-select-strap-type .tab-button[filter-type="${type}"]`);
        $tab.show();
        if (isActive) $tab.addClass('active');
    };
    const loadFallbackStraps = () => {
        // Get saved filter type from sessionStorage
        const selectedFilterBy = sessionStorage.getItem('selectedFilterBy');
        
        if (selectedFilterBy === 'colour') {
      
            // Handle colour filter restoration
            const savedFilterType = sessionStorage.getItem('selectedFilterType');
            const savedFilterCollection = sessionStorage.getItem('selectedFilterCollection');
            const savedStrapColour = sessionStorage.getItem('selectedStrapColour');
            
            // Check if any of the required values are missing
            if (savedFilterType && savedFilterCollection && savedStrapColour) {
           
                
                // Parse savedStrapColour format: "displayText,colorValue"
                const colourParts = savedStrapColour.split(',');
                const savedDisplayText = colourParts[0];
                const savedColourValue = colourParts[1];
                
                // Use saved values from sessionStorage
                const collectionToUse = savedFilterCollection;
                
                // Restore saved colour filter
                $('custom-select-collection-filter').find('.custom-select__option').removeClass('active');
                $('custom-select-collection-filter').find(`[filter-collection="${collectionToUse}"]`).addClass('active');
                
                $('#colour-filter-list custom-select-colour-filter').find('.custom-select__option').removeClass('active');
                const $savedColourOption = $('#colour-filter-list custom-select-colour-filter').find(`[filter-colour="${savedColourValue}"]`);
                $savedColourOption.addClass('active');
                
                // Update the button text with the saved display text and color dot
                const savedColourDot = $savedColourOption.find('.colour-dot');
                $('#colour-filter-list custom-select-colour-filter').find('.custom-select--text').html(
                    `<span class="colour-dot-button" style="background-color: ${savedColourDot.css('background-color')}; width: 12px; height: 12px; border-radius: 50%; display: inline-block; margin-right: 8px;"></span>${savedDisplayText}`
                );
                
                loadStrapsByColour(collectionToUse, savedColourValue, true);
            } else {
               
                
                // Fallback to first options
                const firstCollection = $('custom-select-collection-filter').find('.custom-select__option:first').attr('filter-collection');
                const firstColour = $('#colour-filter-list custom-select-colour-filter').find('.custom-select__option:first').attr('filter-colour');
                const firstDisplayText = $('#colour-filter-list custom-select-colour-filter').find('.custom-select__option:first').attr('filter-colour-display');
                const firstColourDot = $('#colour-filter-list custom-select-colour-filter').find('.custom-select__option:first').find('.colour-dot');
                
                // Set first collection as active
                $('custom-select-collection-filter').find('.custom-select__option').removeClass('active');
                $('custom-select-collection-filter').find('.custom-select__option:first').addClass('active');
                $('custom-select-collection-filter').find('.custom-select--button .custom-select--text').text(
                    $('custom-select-collection-filter').find('.custom-select__option:first').text()
                );
                
                // Set first colour as active
                $('#colour-filter-list custom-select-colour-filter').find('.custom-select__option').removeClass('active');
                $('#colour-filter-list custom-select-colour-filter').find('.custom-select__option:first').addClass('active');
                $('#colour-filter-list custom-select-colour-filter').find('.custom-select--button .custom-select--text').html(
                    `<span class="colour-dot-button" style="background-color: ${firstColourDot.css('background-color')}; width: 12px; height: 12px; border-radius: 50%; display: inline-block; margin-right: 8px;"></span>${firstDisplayText}`
                );

                loadStrapsByColour(firstCollection, firstColour, true);
            }
            
            // Show colour filter tab as active
            $('.filter-tab-button').removeClass('active');
            $('.filter-tab-button[filter-type="colour"]').addClass('active');
            $('#colour-filter-list').css('display', 'flex');
            $('#strap-filter-list').hide();
            
        } else if (selectedFilterBy === 'material') {
            // Handle material filter restoration
            const savedFilterType = sessionStorage.getItem('selectedFilterType');
            const savedFilterCollection = sessionStorage.getItem('selectedFilterCollection');
            const savedStrapMaterial = sessionStorage.getItem('selectedStrapMaterial');
            
            // Check if any of the required values are missing
            if (!savedFilterType || !savedFilterCollection || !savedStrapMaterial) {
                // Fallback to first options
                const firstCollection = $('custom-select-collection-filter').find('.custom-select__option:first').attr('filter-collection');
                const firstMaterial = $('custom-select-material-filter').find('.custom-select--list.active ul li:first').attr('filter-material');
                
                // Set first collection as active
                $('custom-select-collection-filter').find('.custom-select__option').removeClass('active');
                $('custom-select-collection-filter').find('.custom-select__option:first').addClass('active');
                
                // Set first material as active
                $('custom-select-material-filter').find('.custom-select--list.active ul li').removeClass('active');
                $('custom-select-material-filter').find('.custom-select--list.active ul li:first').addClass('active');
                $('custom-select-material-filter').find('.custom-select--button .custom-select--text').text(firstMaterial);
                
                loadStraps(firstCollection, firstMaterial, true);
            } else {
                // Restore saved material filter
                $('custom-select-collection-filter').find('.custom-select__option').removeClass('active');
                $('custom-select-collection-filter').find(`[filter-collection="${savedFilterCollection}"]`).addClass('active');
                
                $('custom-select-material-filter').find('.custom-select--list.active ul li').removeClass('active');
                $('custom-select-material-filter').find(`[filter-material="${savedStrapMaterial}"]`).addClass('active');
                $('custom-select-material-filter').find('.custom-select--button .custom-select--text').text(savedStrapMaterial);
                
                loadStraps(savedFilterCollection, savedStrapMaterial, true);
            }
            
            // Show material filter tab as active
            $('.filter-tab-button').removeClass('active');
            $('.filter-tab-button[filter-type="material"]').addClass('active');
            $('#strap-filter-list').css('display', 'flex');
            $('#colour-filter-list').hide();
            
        } else {
            // Default fallback - no saved filter or invalid filter type - filter by material
            const firstCollection = $('custom-select-collection-filter').find('.custom-select__option:first').attr('filter-collection');
            const firstMaterial = $('custom-select-material-filter').find('.custom-select--list.active ul li:first').attr('filter-material');
            
            // Set first collection as active
            $('custom-select-collection-filter').find('.custom-select__option').removeClass('active');
            $('custom-select-collection-filter').find('.custom-select__option:first').addClass('active');
            const firstCollectionText = $('custom-select-collection-filter').find('.custom-select__option:first').text();
            $('custom-select-collection-filter').find('.custom-select--button .custom-select--text').text(firstCollectionText);
            
            // Set first material as active
            $('custom-select-material-filter').find('.custom-select--list.active ul li').removeClass('active');
            $('custom-select-material-filter').find('.custom-select--list.active ul li:first').addClass('active');
            $('custom-select-material-filter').find('.custom-select--button .custom-select--text').text(firstMaterial);
            
            loadStraps(firstCollection, firstMaterial, true);
            
            // Show material filter tab as active
            $('.filter-tab-button').removeClass('active');
            $('.filter-tab-button[filter-type="material"]').addClass('active');
            $('#strap-filter-list').css('display', 'flex');
            $('#colour-filter-list').hide();
        }        
        showTab('all', true);
    };

    const recommendedHandle = getHandle(recommendedCollection);
    const integratedHandle = getHandle(integratedCollection);

    function checkValidRecommendedStraps(collectionHandle) {
    
        return new Promise((resolve) => {
            if (!collectionHandle) {
                return resolve(false);
            }
    
            const buckleColor = $('.strap-finder-only').attr('buckle-color')?.toLowerCase() || "";
            const watchLugWidth = $('.strap-finder-only').attr('watch-lugwidth');
            const url = `/collections/${collectionHandle}?filter.v.availability=1&view=ajax&limit=10&page=1`;
    
            $.get(url, function(response) {
                try {
                    const parsed = JSON.parse(response);
                    const products = parsed.products || [];
    
                    const cleanLugWidth = (val) => val.replace(/[^\d\-]/g, '').split('-')[0].trim();
    
                    for (let i = 0; i < products.length; i++) {
                        const product = products[i];
                        if (!product.variants?.length) continue;
    
                        const lugIndex = product.options.indexOf("Lug Width (Lug-Buckle)");
    
                        const topAlt = `sf_wvtop_${buckleColor}`;
                        const bottomAlt = `sf_wvbottom_${buckleColor}`;
    
                        const hasTop = product.media?.some(m => m.alt?.includes(topAlt) || m.alt?.includes('sf_wvtop'));
                        const hasBottom = product.media?.some(m => m.alt?.includes(bottomAlt) || m.alt?.includes('sf_wvbottom'));
                        if (!hasTop || !hasBottom) continue;
    
                        const hasAvailableVariant = product.variants.some(v => v.available);
                        if (!hasAvailableVariant) continue;
    
                        if (lugIndex === -1 || !watchLugWidth) {
                            return resolve(true); // ✅ found
                        }
    
                        const matchingVariants = product.variants.filter(v => {
                            const val = v.options?.[lugIndex];
                            if (!val) return false;
                            return cleanLugWidth(val) === watchLugWidth;
                        });
    
                        if (matchingVariants.some(v => v.available)) {
                            return resolve(true); // ✅ found
                        }
    
                        if (matchingVariants.length === 0) {
                            return resolve(true); // ✅ found
                        }
                    }
    
                    resolve(false); // ❌ nothing valid
                } catch (e) {
                    console.warn('Parse error during strap check:', e);
                    resolve(false);
                }
            }).fail(() => {
                resolve(false);
            });
        });
    }
    
    // 👉 check availability before loading
    Promise.all([
        checkValidRecommendedStraps(recommendedHandle),
        checkValidRecommendedStraps(integratedHandle)
      ]).then(([hasRecommended, hasIntegrated]) => {
        const savedTab = sessionStorage.getItem('selectedStrapTab');

        if (sfPageType != 'brand') {
            // === Step 1: Show available tabs based on watchCategory ===
            if (watchCategory === 'sfw' || watchCategory === 'rs no custom' || watchCategory === 'rs and custom') {
                if (hasRecommended) showTab('recommended');
                if (hasIntegrated) showTab('integrated');

                if (watchCategory === 'sfw' || watchCategory === 'rs and custom') {
                    showTab('all');
                }
            } else if (watchCategory === 'custom') {
                if (hasIntegrated) {
                    showTab('integrated');
                } else {
                    showTab('all'); 
                }
            }
        
            // === Step 2: Load correct tab based on savedTab, fallback if not valid ===
            let isValidTabLoaded = false;
        
            if (savedTab === 'recommended' && hasRecommended ) {
            loadRecommendedStraps(recommendedHandle, true);
            showTab('recommended', true);
            isValidTabLoaded = true;
            } else if (savedTab === 'integrated' && hasIntegrated) {
            loadRecommendedStraps(integratedHandle, true);
            showTab('integrated', true);
            isValidTabLoaded = true;
            } else if (savedTab === 'all') {
            loadFallbackStraps();
            isValidTabLoaded = true;
            }
        
            // === Step 3: Fallback if no saved tab or not valid ===
            if (!isValidTabLoaded) {
            if (watchCategory === 'sfw' || watchCategory === 'rs no custom' || watchCategory === 'rs and custom') {
                if (hasRecommended) {
                    loadRecommendedStraps(recommendedHandle, true);
                    showTab('recommended', true);
                    if (hasIntegrated) showTab('integrated');
                } else if (hasIntegrated) {
                showTab('integrated', true);
                loadRecommendedStraps(integratedHandle, true);
                } else {
                loadFallbackStraps();
                }

                if (watchCategory === 'sfw' || watchCategory === 'rs and custom') {
                    showTab('all');
                }

            } else if (watchCategory === 'custom') {
                if (hasIntegrated) {
                showTab('integrated', true);
                loadRecommendedStraps(integratedHandle, true);
                } else {
                loadFallbackStraps();
                }
                showTab('all', true); 
            }
            }
        }else{
            showSectionAfterFlickityLoaded();
        }
      
        // Construct blog slider
        constructBlogSlider(article_urls);
      });
       

}

onloadAppendReturnform = () =>{

    var returnUrl = window.location.pathname + window.location.search;

    // Find all forms inside the modal container
    $('#sf_download_login_modal #customer_login').append(
        '<input type="hidden" name="return_to" value="' + returnUrl + '">'
      );
      $('#sf_download_login_modal #create_customer').append(
        '<input type="hidden" name="return_to" value="' + returnUrl + '">'
      );

      $('#sf_download_login_modal #recover').append(
        '<input type="hidden" name="return_to" value="' + returnUrl + '">'
      );

}


 showTooltipDesc = (targetCategory) =>{
    $('.sf-tooltip-box .lug-width-info').each(function () {
        var category = $(this).attr('watch-category');
      
        if (category === targetCategory) {
          $(this).show();
        } else {
          $(this).hide(); // Optional: hide others
        }
      });
 }
wfSentEmail = () =>{
    var watchBrand = $('.strap-finder-only').attr('watch-brand');
    var watchModel = $('.strap-finder-only').attr('watch-model');
    var watchReference = $('.strap-finder-only').attr('watch-reference');
    var email = "support@delugs.com";
    var subject = `Interest in ${watchBrand} ${watchModel} ${watchReference}`;
    var body = `Hello, I would like to know more about ${watchBrand} ${watchModel} ${watchReference}`;

    var mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
}

showSubFilterDropdown = () =>{
//   $('#strap-filter-list').show();
//   $('.strap-finder__straps-header').css('justify-content','end');
    $('#strap-filter-list custom-select-collection-filter').attr('onclick','toggleStrapFilterDropdown(this)');  
    $('#strap-filter-list custom-select-material-filter').attr('onclick', 'toggleStrapFilterMaterialDropdown(this)');   
//    $('#strap-filter-list.mobile-only').css('display','flex'); 
//    $('#strap-filter-list.mobile-only').css('display','flex'); 
$('#colour-filter-list custom-select-colour-filter').attr('onclick', 'toggleStrapColorDropdown(this)'); 

 
   $('.sf-filter-tabs').css('display','flex'); 
   $('.sf-sub-filter-list').css('display','flex'); 
   $('#collection-filter-list').css('display','flex'); 
   
   // Show the appropriate filter list based on active tab
   var activeTab = $('.filter-tab-button.active').attr('filter-type');
   
   if (activeTab === 'material') {
       $('#strap-filter-list').css('display', 'flex');
       $('#colour-filter-list').css('display', 'none');
   } else if (activeTab === 'colour') {
       $('#colour-filter-list').css('display', 'flex');
       $('#strap-filter-list').css('display', 'none');
   } else {
       // Default to colour if no active tab
       $('#colour-filter-list').css('display', 'flex');
       $('#strap-filter-list').css('display', 'none');
   }
}
hideSubFilterDropdown = () =>{
    $('custom-select-collection-filter').removeClass('custom-select--active');
    $('custom-select-material-filter').removeClass('custom-select--active');
    // $('.strap-finder__straps-header').css('justify-content','center');
    // $('#strap-filter-list').hide();
    $('#strap-filter-list custom-select-collection-filter').removeAttr('onclick'); 
    $('#strap-filter-list custom-select-material-filter').removeAttr('onclick'); 
    $('#strap-filter-list.mobile-only').css('display','none'); 
    $('#strap-filter-list.mobile-only').css('display','none'); 
    
    $('.sf-filter-tabs').css('display','none'); 
    $('.sf-sub-filter-lis').css('display','none'); 
    $('#collection-filter-list').css('display','none'); 
    $('#colour-filter-list').hide(); 
    $('#strap-filter-list').hide(); 
}

constructBlogSlider = (urls) => {
    let urlArray = urls.split(',').map(url => url.trim()).filter(url => url !== "");
    var sliderWrapper = $('<div>').addClass('article-slider-wrapper');
    var ajaxCalls = [];
    var articles = [];

    urlArray.forEach((url, i) => {
        let cleanUrl;
        try {
            cleanUrl = new URL(url).pathname;
        } catch (e) {
            cleanUrl = url;
        }

        let ajaxCall = $.ajax({
            url: cleanUrl,
            cache: false,
            success: function(response) {
                let flexDirection = i % 2 === 0 ? 'row' : 'row-reverse';

                var title = $(response).find('h1').text().trim();
                var postDate = $(response).find('#main-content .post-meta-wrapper time').text().trim(); 
                var thirdParagraph = $(response).find('#main-content .rte p').eq(2).text().trim();
                var preview = thirdParagraph;
                var featuredImage = $(response).find('.blog-post-detail--wrapper .featured-image img').attr('src');

                var articleDiv = $('<div>').addClass('article-slide').css({
                    'display': 'flex',
                    'flex-direction': flexDirection
                });

                var contentWrapper = $('<div>').addClass('jsc-sf-article-featured-img');

                if (featuredImage) {
                    var imgWrapper = $('<div>').addClass('featured-image');
                    var sharpImage = featuredImage.replace(/_345x300/, '_640x550');

                    var img = $('<img>')
                      .attr('src', sharpImage)
                      .attr('alt', title)
                      .attr('width', '640')
                      .attr('height', '550')
                      .addClass('no-blur');

                    imgWrapper.append(img);
                    contentWrapper.append(imgWrapper);
                }

                var metaInfo = $('<div>').addClass('jsc-sf-article-meta-info');
                var descriptionWrapper = $('<div>').addClass('jsc-sf-article-description');
                descriptionWrapper.append(metaInfo);

                metaInfo.append($('<div class="article-date m-b-10" style="color:#8888">').text(postDate));
                metaInfo.append($('<h5>').text(title));
                metaInfo.append($('<div class="rte m-b-10">').text(preview));
                metaInfo.append($('<a class="m-b-10">').attr('href', url).attr('target', '_blank').text('Read more >').css('color', 'var(--color-accent)'));

                articleDiv.append(contentWrapper).append(descriptionWrapper);

                // Save with index
                articles.push({ i, articleDiv });
            },
            error: function() {
                // console.log("Failed to fetch blog article:", cleanUrl);
            }
        });

        ajaxCalls.push(ajaxCall);
    });

    $.when.apply($, ajaxCalls).done(function () {
        // Sort by original index
        articles.sort((a, b) => a.i - b.i);
        
        if (articles.length > 1) {
          articles.forEach(item => {
            sliderWrapper.append(item.articleDiv);
          });
      
          $('.blog-article-wrapper').append(sliderWrapper);
      
          if ($(window).width() < 480) {
            $('.article-slider-wrapper').flickity({
              cellAlign: 'left',
              contain: true,
              wrapAround: false,
              prevNextButtons: true,
              pageDots: false
            });
          }
      
        } else if (articles.length === 1) {
          // Optional: show the one article without slider
          $('.blog-article-wrapper').append(articles[0].articleDiv);
          $('.blog-article-wrapper').addClass('sf-articles-count-' + articles.length);
      
        } else {
          // Hide the parent section if no article found
          $('.blog-article-wrapper').closest('.section-spacing').remove();
        }
      });
      
    
}

onloadSetHeaderInfoNoStrap= (brand,model,reference,watchFace) => {
    var infoText = `${brand} ${model} ${reference}`;
    $('.so-watch-information .text').text(infoText);
    $('.strap-finder-only-no-straps').find('.so-watch-icon-overlay').attr('src',watchFace);
    if ($(window).width() < 480) {
        $('.strap-finder-only-no-straps').find('.so-watch-icon-overlay').attr('width','150').attr('height','150');
    }
}

onloadSetHeaderInfo = (brand,model,col_model,reference,lugWidth) => {
    $('.so-watch-model').text(brand);
    $('.so-watch-info .text').text(brand + ' '+ col_model);
    $('.so-watch-info .year-reference').text(reference);
    $('.so-lug-width').text('Lug Width: '+lugWidth+'mm');
    // $('.so-case-diameter').text('Case Diameter: '+caseDiameter+'mm');
    $('.so-watch-details').text(brand+ ' ' + model + ' ' + reference);

    // pre-select first option
    $('._materialSlider .columns').first().addClass('material-active');

    // set text
    var $material = $('._materialSlider .columns').first().attr('material');
    $('.selected-material').text($material+' Straps');

    //download preview
    $('.sf-download-watch-info-left .sf-brand').text(brand);
    $('.sf-download-watch-info-left .sf-collection').text(model);
    $('.sf-download-watch-info-left .sf-model').text(col_model);
    $('.sf-download-watch-info-left .sf-reference').text(reference);
   

}

loadBrandSpecificStraps = (brand_specific_col, isOnload = false) => {
    // console.log(brand_specific_col, 'brand_specific_col');
    hideSectionBeforeFlickityLoaded();
    showInitialLoadingOverlay(isOnload);

    var strap_container = $('.strap-finder__straps-container');
    destroyStrapFlickity(strap_container);
    strap_container.empty();
    $('.strap-finder-slide-counter .sf-slide-counter').text('');

    let allProducts = [];
    let page = 1;
    let isInitialLoad = true;
    let isLoading = false;
    let hasMorePages = true;

    // load every 50 products
    let productsPerPage = 50;

    function fetchPage() {
        if (isLoading) return;
        isLoading = true;

        let url = `/collections/${brand_specific_col}?filter.v.availability=1&view=ajax&limit=${productsPerPage}&page=${page}`;

        $.ajax({
            url: url,
            cache: false,
            success: function(response) {
                let filterProducts = JSON.parse(response);
                // console.log(`Fetched products from Page ${page}:`, filterProducts.products);

                if (filterProducts.products.length === 0) {
                    hasMorePages = false;
                    isLoading = false;
                    hideVideoLoadingOverlay();
                    return;
                }

                allProducts = allProducts.concat(filterProducts.products);

                displayProducts(filterProducts.products, isInitialLoad);
                isInitialLoad = false;

                // After the first fetch, switch to 50 products per page
                // if (page === 1) {
                //     productsPerPage = 50;
                // }

                page++;
                isLoading = false;

                if (hasMorePages) {
                    setTimeout(() => {
                        fetchPage();
                        var flkty = $('.strap-finder__straps-container').data('flickity');
                        $('.strap-finder__straps-container').flickity('reloadCells');
                        $('.strap-finder__straps-container').flickity('resize');
                        $('.strap-finder__straps-container').flickity('select', flkty.selectedIndex, false, true); // force re-cente
                    }, 300);
                }
            },
            error: function(error) {
                // console.log('Error fetching data:', error);
                isLoading = false;
                $('.jsc-page-loading').remove();
            }
        });
    }

    fetchPage(); // Start fetching
};



loadRecommendedStraps = (recommended_col_handle, isOnload = false) => {
    hideSectionBeforeFlickityLoaded();
    showInitialLoadingOverlay(isOnload);

    const strap_container = $('.strap-finder__straps-container');
    destroyStrapFlickity(strap_container);
    strap_container.empty();

    let page = 1;
    let isInitialLoad = true;
    let isLoading = false;
    let hasMorePages = true;
    let productsPerPage = 10;

    const buckleColor = $('.strap-finder-only').attr('buckle-color')?.toLowerCase() || "";
    const watchLugWidth = $('.strap-finder-only').attr('watch-lugwidth');

    function fetchPage() {
        if (isLoading) return;
        isLoading = true;

        const url = `/collections/${recommended_col_handle}?filter.v.availability=1&view=ajax&limit=${productsPerPage}&page=${page}`;

        $.ajax({
            url,
            cache: false,
            success: function(response) {
                const parsed = JSON.parse(response);
                const products = parsed.products;

                if (!products.length) {
                    hasMorePages = false;
                    isLoading = false;
                    hideVideoLoadingOverlay();
                    return;
                }

                const validProducts = products.filter(product => {
                    if (!product.variants?.length) return false;

                    const lugIndex = product.options.indexOf("Lug Width (Lug-Buckle)");

                    const topAlt = `sf_wvtop_${buckleColor}`;
                    const bottomAlt = `sf_wvbottom_${buckleColor}`;

                    const hasTop = product.media?.some(m => m.alt?.includes(topAlt) || m.alt?.includes('sf_wvtop'));
                    const hasBottom = product.media?.some(m => m.alt?.includes(bottomAlt) || m.alt?.includes('sf_wvbottom'));

                    if (!hasTop || !hasBottom) return false;

                    const hasAvailableVariant = product.variants.some(v => v.available);
                    if (!hasAvailableVariant) return false;

                    // If no lug width defined or watch doesn't have lug width — show
                    if (lugIndex === -1 || !watchLugWidth) {
                        return true;
                    }

                    // Clean the lug width value (handle "18mm", "18-22mm", etc.)
                    const cleanLugWidth = (val) => val.replace(/[^\d\-]/g, '').split('-')[0].trim();

                    // Find all matching lug width variants
                    const matchingVariants = product.variants.filter(v => {
                        const val = v.options?.[lugIndex];
                        if (!val) return false;
                        return cleanLugWidth(val) === watchLugWidth;
                    });

                    // If any matching variant exists and is in stock → show
                    if (matchingVariants.some(v => v.available)) return true;

                    // If matching variants exist but ALL are OOS → hide
                    if (matchingVariants.length > 0) return false;

                    // If no matching variant exists at all, but at least one variant is available → show
                    return true;
                });

                displayProducts(validProducts, isInitialLoad);
                isInitialLoad = false;

                if (page === 1) productsPerPage = 50;

                page++;
                isLoading = false;

                if (hasMorePages) {
                    setTimeout(() => {
                        fetchPage();
                        const flkty = $('.strap-finder__straps-container').data('flickity');
                        $('.strap-finder__straps-container').flickity('reloadCells');
                        $('.strap-finder__straps-container').flickity('resize');
                        $('.strap-finder__straps-container').flickity('select', flkty.selectedIndex, false, true);
                        refreshCarouselAndCounter();
                    }, 300);
                }
            },
            error: function(err) {
                // console.log("Error fetching data:", err);
                isLoading = false;
                $('.jsc-page-loading').remove();
            }
        });
    }

    fetchPage();
};



function refreshCarouselAndCounter() {
    const $carousel = $('.strap-finder__straps-container');
    var flkty = $carousel.data('flickity');
    $carousel.flickity('reloadCells');          
    $carousel.flickity('resize');
    $carousel.flickity('select', flkty.selectedIndex, false, true); // force re-cente

    const current = flkty.selectedIndex + 1;
    const total = flkty.slides.length;
    $('.strap-finder-slide-counter .sf-slide-counter').text(`${current} / ${total}`);
  }


  loadStrapsByColour = (collection_handle, colour_filter, isOnload = false) => {
    showSubFilterDropdown();
    hideSectionBeforeFlickityLoaded();
    showInitialLoadingOverlay(isOnload);

    var strap_container = $('.strap-finder__straps-container');
    destroyStrapFlickity(strap_container);
    strap_container.empty();
    // console.log(collection_filter,colour_filter); 

    let allProducts = [];
    let page = 1;
    let isInitialLoad = true;
    let isLoading = false;
    let hasMorePages = true;

    // Initial load: 10 products, next loads: 50
    let productsPerPage = 10;

    let unicodeSstrapColour = customColorEncode(colour_filter);
    let buckleColor = $('.strap-finder-only').attr('buckle-color')?.toLowerCase() || "";
    const watchLugWidth = $('.strap-finder-only').attr('watch-lugwidth');

    function fetchPage() {
        if (isLoading) return;
        isLoading = true;

        let url = `/collections/${collection_handle}?filter.v.availability=1&filter.p.m.filter.colour=${unicodeSstrapColour}&view=ajax&limit=${productsPerPage}&page=${page}`;
// console.log(url,'url');

        $.ajax({
            url: url,
            cache: false,
            success: function(response) {  
                const parsed = JSON.parse(response);
                const products = parsed.products;

                if (!products.length) {
                    hasMorePages = false;
                    isLoading = false;
                    hideVideoLoadingOverlay();
                    return;
                }

                const validProducts = products.filter(product => {
                    // console.log(`\n🔍 Checking product: ${product.title} (${product.handle})`);

                    if (!product.variants?.length) {
                        // console.log('❌ Rejected: No variants.');
                        return false;
                    }

                    const lugIndex = product.options.indexOf("Lug Width (Lug-Buckle)");

                    const topAlt = `sf_wvtop_${buckleColor}`;
                    const bottomAlt = `sf_wvbottom_${buckleColor}`;

                    const hasTop = product.media?.some(m => m.alt?.includes(topAlt) || m.alt?.includes('sf_wvtop'));
                    const hasBottom = product.media?.some(m => m.alt?.includes(bottomAlt) || m.alt?.includes('sf_wvbottom'));

                    if (!hasTop || !hasBottom) {
                        // console.log(`❌ Rejected: Missing required images. hasTop: ${hasTop}, hasBottom: ${hasBottom}`);
                        return false;
                    }

                    const hasAvailableVariant = product.variants.some(v => v.available);
                    if (!hasAvailableVariant) {
                        // console.log('❌ Rejected: No available variants.');
                        return false;
                    }

                    // If no lug width defined or watch doesn't have lug width — accept
                    if (lugIndex === -1 || !watchLugWidth) {
                        // console.log('✅ Accepted: No lug width check needed.');
                        return true;
                    }

                    // Clean the lug width value (handle "18mm", "18-22mm", etc.)
                    const cleanLugWidth = (val) => val.replace(/[^\d\-]/g, '').split('-')[0].trim();

                    const matchingVariants = product.variants.filter(v => {
                        const val = v.options?.[lugIndex];
                        if (!val) return false;
                        return cleanLugWidth(val) === watchLugWidth;
                    });

                    if (matchingVariants.some(v => v.available)) {
                        // console.log(`✅ Accepted: Matching lug width "${watchLugWidth}" found and in stock.`);
                        return true;
                    }

                    if (matchingVariants.length > 0) {
                        // console.log(`❌ Rejected: Matching lug width "${watchLugWidth}" exists but all are OOS.`);
                        return false;
                    }

                    // console.log(`✅ Accepted: No matching lug width, but other variants are available.`);
                    return true;
                });


                allProducts = allProducts.concat(validProducts);
                displayProducts(validProducts, isInitialLoad);
                isInitialLoad = false;

                // After first fetch, set productsPerPage to 50 for next pages
                if (page === 1) productsPerPage = 50;

                page++;
                isLoading = false;

                if (hasMorePages) {
                    setTimeout(() => {
                        fetchPage();
                        var flkty = $('.strap-finder__straps-container').data('flickity');
                        $('.strap-finder__straps-container').flickity('reloadCells');
                        $('.strap-finder__straps-container').flickity('resize');
                        $('.strap-finder__straps-container').flickity('select', flkty.selectedIndex, false, true); // force re-cente
                    }, 300);
                }
            },
            error: function(error) {
                // console.log('Error fetching data:', error);
                isLoading = false;
                $('.jsc-page-loading').remove();
            }
        });
    }

    fetchPage(); // Start fetching process
};

loadStraps = (collection_handle, material_filter, isOnload = false) => {
    showSubFilterDropdown();
    hideSectionBeforeFlickityLoaded();
    showInitialLoadingOverlay(isOnload);

    var strap_container = $('.strap-finder__straps-container');
    destroyStrapFlickity(strap_container);
    strap_container.empty();
    // console.log(collection_filter,material_filter); 

    let allProducts = [];
    let page = 1;
    let isInitialLoad = true;
    let isLoading = false;
    let hasMorePages = true;

    // Initial load: 10 products, next loads: 50
    let productsPerPage = 10;

    let unicodeStrapMaterial = customUrlEncode(material_filter);
    let buckleColor = $('.strap-finder-only').attr('buckle-color')?.toLowerCase() || "";
    const watchLugWidth = $('.strap-finder-only').attr('watch-lugwidth');

    function fetchPage() {
        if (isLoading) return;
        isLoading = true;

        let url = `/collections/${collection_handle}?filter.v.availability=1&filter.p.m.custom.leather_pattern=${unicodeStrapMaterial}&view=ajax&limit=${productsPerPage}&page=${page}`;
// console.log(url,'url');

        $.ajax({
            url: url,
            cache: false,
            success: function(response) {  
                const parsed = JSON.parse(response);
                const products = parsed.products;

                if (!products.length) {
                    hasMorePages = false;
                    isLoading = false;
                    hideVideoLoadingOverlay();
                    return;
                }

                const validProducts = products.filter(product => {
                    // console.log(`\n🔍 Checking product: ${product.title} (${product.handle})`);

                    if (!product.variants?.length) {
                        // console.log('❌ Rejected: No variants.');
                        return false;
                    }

                    const lugIndex = product.options.indexOf("Lug Width (Lug-Buckle)");

                    const topAlt = `sf_wvtop_${buckleColor}`;
                    const bottomAlt = `sf_wvbottom_${buckleColor}`;

                    const hasTop = product.media?.some(m => m.alt?.includes(topAlt) || m.alt?.includes('sf_wvtop'));
                    const hasBottom = product.media?.some(m => m.alt?.includes(bottomAlt) || m.alt?.includes('sf_wvbottom'));

                    if (!hasTop || !hasBottom) {
                        // console.log(`❌ Rejected: Missing required images. hasTop: ${hasTop}, hasBottom: ${hasBottom}`);
                        return false;
                    }

                    const hasAvailableVariant = product.variants.some(v => v.available);
                    if (!hasAvailableVariant) {
                        // console.log('❌ Rejected: No available variants.');
                        return false;
                    }

                    // If no lug width defined or watch doesn't have lug width — accept
                    if (lugIndex === -1 || !watchLugWidth) {
                        // console.log('✅ Accepted: No lug width check needed.');
                        return true;
                    }

                    // Clean the lug width value (handle "18mm", "18-22mm", etc.)
                    const cleanLugWidth = (val) => val.replace(/[^\d\-]/g, '').split('-')[0].trim();

                    const matchingVariants = product.variants.filter(v => {
                        const val = v.options?.[lugIndex];
                        if (!val) return false;
                        return cleanLugWidth(val) === watchLugWidth;
                    });

                    if (matchingVariants.some(v => v.available)) {
                        // console.log(`✅ Accepted: Matching lug width "${watchLugWidth}" found and in stock.`);
                        return true;
                    }

                    if (matchingVariants.length > 0) {
                        // console.log(`❌ Rejected: Matching lug width "${watchLugWidth}" exists but all are OOS.`);
                        return false;
                    }

                    // console.log(`✅ Accepted: No matching lug width, but other variants are available.`);
                    return true;
                });


                allProducts = allProducts.concat(validProducts);
                displayProducts(validProducts, isInitialLoad);
                isInitialLoad = false;

                // After first fetch, set productsPerPage to 50 for next pages
                if (page === 1) productsPerPage = 50;

                page++;
                isLoading = false;

                if (hasMorePages) {
                    setTimeout(() => {
                        fetchPage();
                        var flkty = $('.strap-finder__straps-container').data('flickity');
                        $('.strap-finder__straps-container').flickity('reloadCells');
                        $('.strap-finder__straps-container').flickity('resize');
                        $('.strap-finder__straps-container').flickity('select', flkty.selectedIndex, false, true); // force re-cente
                    }, 300);
                }
            },
            error: function(error) {
                // console.log('Error fetching data:', error);
                isLoading = false;
                $('.jsc-page-loading').remove();
            }
        });
    }

    fetchPage(); // Start fetching process
};




customUrlEncode= (str) => {
    // First, use encodeURIComponent to encode all characters
    let encoded = encodeURIComponent(str);
    
    // Now replace spaces with '+', and slashes with '%2F'
    encoded = encoded.split('%20').join('+'); // Replace %20 with '+'
    encoded = encoded.split('%2F').join('%2F'); // Replace %2F (slash) explicitly (no change here)

    return encoded;
}

customColorEncode = (str) => {
    // For all colors, capitalize first letter and replace hyphens with +%2F+
    let encoded = str.split('-').map(word => 
        word.charAt(0).toUpperCase() + word.slice(1)
    ).join('+%2F+');
    
    return encoded;
}

displayProducts = (products, isInitial) => {
    const strap_container = $('.strap-finder__straps-container');
    const buckleColor = $('.strap-finder-only').attr('buckle-color')?.toLowerCase() || "";
    const isMobile = window.innerWidth <= 798;

    if (products.length === 0 && isInitial) {
        $('.shopify-section').not('.shopify-section-group-header-group, .shopify-section-group-footer-group').css('display', 'block');
        $('.strap-finder__straps-header').css('display','flex');
        strap_container.append("<p class='p-l-10'>No products found in this collection.</p>");
        $('.strap-finder-slide-counter .sf-slide-counter').css('visibility','hidden');
        return;
    }else{
        $('.strap-finder-slide-counter .sf-slide-counter').css('visibility','visible');
    }

    if (isInitial) {
        globalIndexCount = 0;
        globalDisplayedCount = 0;
    }

    globalDisplayedCount += products.length;
    
    // ✅ Different crop parameters for mobile vs desktop
    const cropEnabled = isMobile || globalDisplayedCount >= 4;
    
    // Mobile crop parameters (more aggressive cropping for smaller screens)
    const mobileCropParams = "crop=region&crop_height=640&crop_left=335&crop_top=0&crop_width=520";
    
    // Desktop crop parameters (less aggressive cropping for larger screens)
    const desktopCropParams = "crop=region&crop_height=640&crop_left=195&crop_top=0&crop_width=800";
    
    // Use mobile crop if on mobile, otherwise use desktop crop
    const cropParams = isMobile ? mobileCropParams : desktopCropParams;

    const applyCrop = (url) => {
        if (!url) return "";
        const [base, version] = url.split('?v=');
        return cropEnabled ? `${base}?${cropParams}&v=${version}` : `${base}?v=${version}`;
    };

    let productHTML = "";

    products.forEach((product, i) => {
        const topAlt = `sf_wvtop_${buckleColor}`;
        const bottomAlt = `sf_wvbottom_${buckleColor}`;

        const topImg = product.media?.find(m => m.alt?.includes(topAlt)) || product.media?.find(m => m.alt?.includes('sf_wvtop'));
        const bottomImg = product.media?.find(m => m.alt?.includes(bottomAlt)) || product.media?.find(m => m.alt?.includes('sf_wvbottom'));

        if (!topImg?.src || !bottomImg?.src) return;

        const topUrl = applyCrop(topImg.src);
        const bottomUrl = applyCrop(bottomImg.src);

        let sfTop_margin = 0;
        let sfBottom_margin = 0;

        if (window.innerWidth <= 480 && i === 1) {
            sfTop_margin = $('.strap-finder-only').attr('sfTop_margin');
            sfBottom_margin = $('.strap-finder-only').attr('sfBottom_margin');
        } else if (window.innerWidth > 480 && i === 2) {
            sfTop_margin = $('.strap-finder-only').attr('sfTop_margin');
            sfBottom_margin = $('.strap-finder-only').attr('sfBottom_margin');
        }

        productHTML += `
            <div class="columns ${globalIndex}" 
                 product-title="${product.title}" 
                 product-handle="${product.handle}">
                <img class="sf-top-strap no-blur lazyautosizes lazyloaded" src="${topUrl}" alt="${product.title}" style="top:${sfTop_margin}px">
                <img class="sf-bottom-strap no-blur lazyautosizes lazyloaded" src="${bottomUrl}" alt="${product.title}" style="top:${sfBottom_margin}px">
            </div>
        `;

        globalIndexCount++;
    });

    if (isInitial) {
        strap_container.append(productHTML);

        strap_container.removeClass((i, c) =>
            (c.match(/(^|\s)strap-count-\d+|strap-count-more/g) || []).join(' ')
        );

        // if (globalDisplayedCount >= 1 && globalDisplayedCount <= 5) {
        //     strap_container.addClass('strap-count-more');
        // } else if (globalDisplayedCount > 5) {
            strap_container.addClass('strap-count-more');
        // }

        // Wait until all images are loaded before continuing
        imagesLoaded(strap_container[0], function() {
            $('.jsc-page-loading').remove(); // ✅ Hide loader
            materialStrapsFlickity();         // ✅ Initialize or reinit Flickity
            updateStrapOverlay();
            loadSelectedProduct();
        });

    } else {
        const $newCells = $(productHTML);
        const flkty = strap_container.data('flickity');
        strap_container.flickity('append', $newCells);
        flkty.reloadCells();
        refreshCarouselAndCounter();

        const containerHeight = strap_container.height();
        if (containerHeight < 50) {
            destroyStrapFlickity(strap_container);
            materialStrapsFlickity();
        }
    }
};


loadSelectedProduct = () => {

    var getLugWidth =  $('.strap-finder-only').attr('watch-lugwidth');
    var watchcategory = $('.strap-finder-only').attr('watch-category');
    var customPageUrl = $('.strap-finder-only').attr('custom-page-url');
    var actualLugWidth = $('.strap-finder-only').attr('watch-actualLugWidth');
    var strapType = $('.strap-finder-only custom-select-strap-type').find('.tab-button.active').text();
    var product_title = $('.strap-finder__straps-container').find('.columns.is-selected').attr('product-title');
    $('.selected-product .title').text(product_title);

    if (!actualLugWidth || actualLugWidth === 'N/A') {
        $('.actual-lug-width').parent('p').remove();
    }else{
        $('.actual-lug-width').text(actualLugWidth+ ' mm');
    }

    var product_handle = $('.strap-finder__straps-container').find('.columns.is-selected').attr('product-handle');

    var sfPageType = $('.strap-finder-only').attr('sf-page-type');
    if (sfPageType == 'brand'){
        $('.buy-custom-strap').text('Buy Strap');
        $('.availability-status').empty().append('<span class="dot"></span>  Available').css('color','#008000');
        $('.buy-custom-strap').parent().attr('href', '/products/' + product_handle + '?lugwidth:'+getLugWidth);
    }else{
        if (strapType.includes('Recommended') || strapType.includes('Integrated')) {  
            $('.buy-custom-strap').text('Buy Strap');
            $('.availability-status').empty().append('<span class="dot"></span>  Available').css('color','#008000');
            $('.buy-custom-strap').parent().attr('href', '/products/' + product_handle + '?lugwidth:'+getLugWidth);
        }else{
            if  (watchcategory == 'rs and custom' || watchcategory == 'custom') {
                $('.buy-custom-strap').parent().attr('href', customPageUrl);
                $('.buy-custom-strap').text('Place Custom Order');
                $('.availability-status').empty().text('Available as a custom strap').css('color','#888888');
            }else{
                    $('.buy-custom-strap').text('Buy Strap');
                    $('.availability-status').empty();
                    $('.buy-custom-strap').parent().attr('href', '/products/' + product_handle + '?lugwidth:'+getLugWidth);
            }
        }
    }

    // download preview
    $('.sf-download-watch-info-right .sf-product-title').text(product_title);
    $('.sf-download-watch-info-right .sf-actual-lug-width').text(actualLugWidth);
}

hideSectionBeforeFlickityLoaded =  () => {
    $('.shopify-section').not('.shopify-section-group-header-group, .shopify-section-group-footer-group').css('opacity', '0');
    $('.shopify-section').not('.shopify-section-group-header-group, .shopify-section-group-footer-group').css('visibility', 'hidden');
    $('.section-spacing.strap-finder-only').css('height', '2000px');
    // $('.strap-finder__straps-header').css('display','none');
    // $('.strap-finder__straps-footer').css('display','none');
    // $('view-colour-button-desktop').css('display','none');

    // if ($(window).width() < 480) {
        // $('view-colour-button').css('display','none');
        // $('.mobile .so-watch-info-wrapper').css('display','none'); 
    // }
}

showSectionAfterFlickityLoaded =  () => {
    var sf_page_handle = $('.jsc-watch-finder').attr('sf-page');
    var urlParams = new URLSearchParams(window.location.search);
    var hasBrandParam = urlParams.has('brand');
    
    // Check if on strap finder page WITHOUT brand parameter
    if (window.location.pathname == `/pages/${sf_page_handle}`) {
        if (!hasBrandParam) {
            // On strap finder page without parameters - show all sections except strap_only section
            $('.shopify-section').not('.shopify-section-group-header-group, .shopify-section-group-footer-group, [id*="strap_only"]').css('opacity', '1');
            $('.shopify-section').not('.shopify-section-group-header-group, .shopify-section-group-footer-group, [id*="strap_only"]').css('visibility', 'visible');
        } else {
            // On strap finder page WITH parameters - show all sections
            $('.shopify-section').not('.shopify-section-group-header-group, .shopify-section-group-footer-group').css('opacity', '1');
            $('.shopify-section').not('.shopify-section-group-header-group, .shopify-section-group-footer-group').css('visibility', 'visible');
            // But inside #main-content, remove all sections except strap_only
            $('#main-content').find('.shopify-section').not('[id*="strap_only"]').remove();
            $('.section-spacing.strap-finder-only').css('height', 'auto');
        }
    }else{
        $('.shopify-section').not('.shopify-section-group-header-group, .shopify-section-group-footer-group').css('opacity', '1');
        $('.shopify-section').not('.shopify-section-group-header-group, .shopify-section-group-footer-group').css('visibility', 'visible');
        $('.section-spacing.strap-finder-only').css('height', 'auto');
    }

    // $('.strap-finder__straps-header').css('display','flex');
    // $('.strap-finder__straps-footer').css('display','flex');
    // $('view-colour-button-desktop').css('display','block');
 
    // if ($(window).width() < 480) {
    //     $('view-colour-button').css('display','block');
        // $('.mobile .so-watch-info-wrapper').css('display','flex');
    // }
}
materialStrapsFlickity = () => {
    const $firstContainer = $('.strap-finder__straps-container').first();
    const $allContainers = $('.strap-finder__straps-container');
    let $items = $firstContainer.children('.columns');
    const itemCount = $items.length;
    // Set different target counts for desktop vs mobile
    const targetCount = window.innerWidth <= 480 ? 4 : 6;

    if (itemCount < targetCount) {
      
        $allContainers.each(function () {
          let $container = $(this);
          while ($container.children('.columns').length < targetCount) {
            $items.clone().appendTo($container);
          }
        });
    }

    const $carousel = $('.strap-finder__straps-container').flickity({
      cellAlign: 'center',
      contain: false,
      pageDots: true,         
      draggable: true, // allow drag/swipe
      touchVerticalScroll: false, // ✅ important: prevents vertical interference
      prevNextButtons: true,     
      wrapAround: true,
      touchVerticalScroll: false 
    });
  
    // $('.jsc-page-loading').remove();
    showSectionAfterFlickityLoaded();
    const flkty = $carousel.data('flickity');
    const $counter = $('.strap-finder-slide-counter .sf-slide-counter');
  
    // === Function: Update slide counter ===
    const setSlideCounter = () => {
      if (!flkty || !flkty.slides?.length) return;
      const current = flkty.selectedIndex + 1;
      const total = flkty.slides.length;
      $counter.text(`${current} / ${total}`);
    //   console.log(`Slide counter updated: ${current} / ${total}`);
    };
  
    // === Function: Style dot progress bar ===
    const updateDotProgress = () => {
      const $dots = $('.flickity-page-dots .dot');
      const selectedIndex = flkty.selectedIndex;
  
      $dots.each(function (index) {
       if (index === selectedIndex) {
          $(this).css('background-color', 'black');
        } else {
          $(this).css('background-color', 'white');
        }
      });
    }; 
  

    // === Function: Apply top & bottom strap margins and update preview ===
    function applyStrapMargins() {
      var selectedItem = $carousel.find('.columns.is-selected');
      var sfTop_margin = $('.strap-finder-only').attr('sfTop_margin') || 0;
      var sfBottom_margin = $('.strap-finder-only').attr('sfBottom_margin') || 0;
  
      selectedItem.find('.sf-top-strap').css('top', sfTop_margin + 'px');
      selectedItem.find('.sf-bottom-strap').css('top', sfBottom_margin + 'px');
    }

    function hideCounterAndProgress() {
        if (itemCount < targetCount) {
            $firstContainer.find('.flickity-page-dots').hide();
            $('.strap-finder-slide-counter .sf-slide-counter').css('visibility','hidden');
          } else {
            $firstContainer.find('.flickity-page-dots').show();
            $('.strap-finder-slide-counter .sf-slide-counter').css('visibility','visible');
          }
      }

    setTimeout(() => {
    //   console.log('✅ Flickity ready - second check');
      setSlideCounter();
      updateDotProgress();
      applyStrapMargins();
      hideCounterAndProgress();
    }, 500);
  
    // ✅ On slide change
    $carousel.on('change.flickity', function () {
      setSlideCounter();
      updateDotProgress();
      loadSelectedProduct();
      updateStrapOverlay();
      applyStrapMargins();
  
      $carousel.find('.columns img').css('margin-top', '0');

       // 🟢 Also update the clone if it exists
       var $selectedColumn = $('.sf-front-end').find('.columns.is-selected').children();
       
       if ($selectedColumn.length) {
         // Clone the children
         var $selectedClone = $selectedColumn.clone();
       
         // Find the .columns.is-selected in the clone
         var $cloneSelected = $('#sf-selected-preview  .columns.is-selected');
       
         // Remove its current children
         $cloneSelected.empty();
       
         // Append the cloned children
         $cloneSelected.append($selectedClone);
    
       }
        
    // var strapImages = selectedItem.find('img.sf-top-strap, img.sf-bottom-strap').clone();
    // // Clear old images and append new ones
    // $('#sf-selected-preview .products .columns').empty().append(strapImages);

    });
    
    $('.strap-finder__straps-container').flickity('reloadCells');                
    $('.strap-finder__straps-container').flickity('resize');
    $('.strap-finder__straps-container').flickity('select', flkty.selectedIndex, false, true); // force re-cente
  };

  
updateStrapOverlay = () => {
    setTimeout(() => {
        var $selectedImage = $('.strap-finder__straps-container .columns.is-selected img');
        var $selectedImage_top = $('.strap-finder__straps-container.sf-front-end .columns.is-selected img.sf-top-strap').height();
        var $selectedImage_bottom = $('.strap-finder__straps-container.sf-front-end .columns.is-selected img.sf-bottom-strap').height();
        var $height = $selectedImage_top + $selectedImage_bottom ;
      
        var $dw_selectedImage_top = $('#sf-selected-preview .columns.is-selected img.sf-top-strap').height();
        var $dw_selectedImage_bottom = $('#sf-selected-preview .columns.is-selected img.sf-bottom-strap').height();
        var $dw_height = $dw_selectedImage_top + $dw_selectedImage_bottom ;

        var watchFace = $('.strap-finder-only').attr('watch-face');
        let cropParams = "crop=region&crop_height=1000&crop_left=100&crop_top=30&crop_width=800";

        // Helper to insert crop params before ?v= or add if missing
        function addCropParams(url, cropParams) {
            if (!url) return "";
            if (url.includes('?v=')) {
                // Insert crop params before ?v=
                return url.replace(/\?v=/, `?${cropParams}&v=`);
            } else if (url.includes('?')) {
                // Has other params? append with &
                return url + '&' + cropParams;
            } else {
                // No params? add ?
                return url + '?' + cropParams;
            }
        }
  
        if ($selectedImage.length > 0 && watchFace) {
            // Update watchFace url to include crop parameters properly
            let croppedWatchFaceUrl = addCropParams(watchFace, cropParams);
    
            $('.section-spacing .watch-preview-img')
                .css({
                    "position": "absolute"
                })
                .html(` 
                    <img class="watch-face" src="${croppedWatchFaceUrl}" 
                         style="height:${$height}px!important">
                `);

                $('.section-spacing #sf-selected-preview .sf-download-watch-preview-img')
                .css({
                    "position": "absolute"
                })
                .html(` 
                    <img class="watch-face" src="${croppedWatchFaceUrl}" 
                         style="height:${$dw_height}px!important">
                `);
        }
    }, 1000);    
}

updateFilterProductCount = () => {
    let $lists = $('custom-select-material-filter .custom-select--list');
    const watchLugWidth = $('.strap-finder-only').attr('watch-lugwidth');
  
    $lists.each(function () {
      let $list = $(this);
      let collectionFilter = $list.attr('filter-collection');
  
      if (collectionFilter) {
        let promises = [];
  
        $list.find('ul li').each(function () {
          let $currentLi = $(this);
          let materialFilter = $currentLi.attr('filter-material');
          $currentLi.find('.product-count').remove();
  
          if (materialFilter) {
            let unicodeStrapMaterial = customUrlEncode(materialFilter);
  
            const fetchPage = async (page) => {
              let url = `/collections/${collectionFilter}?filter.v.availability=1&filter.p.m.custom.leather_pattern=${unicodeStrapMaterial}&view=ajax&limit=50&page=${page}`;
              return $.ajax({ url: url, cache: true }).then(response => {
                let data = JSON.parse(response);
                return data.products || [];
              });
            };
  
            let promise = (async () => {
            //   console.groupCollapsed(`🔍 Filter: ${materialFilter} | Collection: ${collectionFilter}`);
              let allProducts = [];
              let page = 1;
              let hasMore = true;
  
              while (hasMore) {
                let products = await fetchPage(page);
                if (products.length === 0) {
                  hasMore = false;
                } else {
                  allProducts = allProducts.concat(products);
                  page++;
                }
              }

              let validProducts = allProducts.filter(product => {
                  const topImage = product.media?.some(media => media.alt?.includes('sf_wvtop'));
                  const bottomImage = product.media?.some(media => media.alt?.includes('sf_wvbottom'));
              
                  if (!topImage || !bottomImage) return false;
                  if (!product.variants || !product.variants.length) return false;
              
                  const hasAvailableVariant = product.variants.some(variant => variant.available);
                  if (!hasAvailableVariant) return false;
              
                  const lugOptionIndex = product.options?.indexOf("Lug Width (Lug-Buckle)");
                  
                  // ✅ No lug width defined in product or watch — show
                  if (lugOptionIndex === -1 || !watchLugWidth) {
                      return true;
                  }
              
                  const cleanLugWidth = (val) => val.replace(/[^\d\-]/g, '').split('-')[0].trim();
              
                  let hasMatching = false;
                  let hasMatchingInStock = false;
              
                  product.variants.forEach(variant => {
                      const val = variant.options?.[lugOptionIndex];
                      if (!val) return;
              
                      const lugStart = cleanLugWidth(val);
                      if (lugStart === watchLugWidth) {
                          hasMatching = true;
                          if (variant.available) {
                              hasMatchingInStock = true;
                          }
                      }
                  });
              
                  // ❌ Hide if matching lug width exists but all are OOS
                  if (hasMatching && !hasMatchingInStock) return false;
              
                  // ✅ Show otherwise (includes: no match at all, but still in-stock variants exist)
                  return true;
              });
              
  
              let currentText = $currentLi.clone().children().remove().end().text();
              $currentLi.html(currentText + ` <span class="product-count">(${validProducts.length})</span>`);
              // ❌ Hide li if count is 0
              if (validProducts.length === 0) {
                $currentLi.hide();
              } else {
                $currentLi.show(); // ensure visible if count > 0
              }

              return validProducts.length;;
            })();
  
            promises.push(promise);
          }
        });
  
        Promise.all(promises).then(() => {
        //   console.log('✅ All product counts updated');
        }).catch(error => {
          console.error('❌ Error updating product counts:', error);
        });
      }
    });
}  

updateFilterColourProductCount = () => {
    let $lists = $('custom-select-colour-filter .custom-select--list');
    const watchLugWidth = $('.strap-finder-only').attr('watch-lugwidth');
  
    $lists.each(function () {
      let $list = $(this);
      let collectionFilter = $('#collection-filter-list custom-select-collection-filter').find('.custom-select__option.active').attr('filter-collection');
  
      if (collectionFilter) {
        let promises = [];
  
        $list.find('ul li').each(function () {
          let $currentLi = $(this);
          let colourFilter = $currentLi.attr('filter-colour');
          $currentLi.find('.product-count').remove();
  
          if (colourFilter) {
            let unicodeStrapColour = customColorEncode(colourFilter);
  
            const fetchPage = async (page) => {
              let url = `/collections/${collectionFilter}?filter.v.availability=1&filter.p.m.filter.colour=${unicodeStrapColour}&view=ajax&limit=50&page=${page}`;
              return $.ajax({ url: url, cache: true }).then(response => {
                let data = JSON.parse(response);
                return data.products || [];
              });
            };
  
            let promise = (async () => {
              let allProducts = [];
              let page = 1;
              let hasMore = true;
  
              while (hasMore) {
                let products = await fetchPage(page);
                if (products.length === 0) {
                  hasMore = false;
                } else {
                  allProducts = allProducts.concat(products);
                  page++;
                }
              }

              let validProducts = allProducts.filter(product => {
                  const topImage = product.media?.some(media => media.alt?.includes('sf_wvtop'));
                  const bottomImage = product.media?.some(media => media.alt?.includes('sf_wvbottom'));
              
                  if (!topImage || !bottomImage) return false;
                  if (!product.variants || !product.variants.length) return false;
              
                  const hasAvailableVariant = product.variants.some(variant => variant.available);
                  if (!hasAvailableVariant) return false;
              
                  const lugOptionIndex = product.options?.indexOf("Lug Width (Lug-Buckle)");
                  
                  // ✅ No lug width defined in product or watch — show
                  if (lugOptionIndex === -1 || !watchLugWidth) {
                      return true;
                  }
              
                  const cleanLugWidth = (val) => val.replace(/[^\d\-]/g, '').split('-')[0].trim();
              
                  let hasMatching = false;
                  let hasMatchingInStock = false;
              
                  product.variants.forEach(variant => {
                      const val = variant.options?.[lugOptionIndex];
                      if (!val) return;
              
                      const lugStart = cleanLugWidth(val);
                      if (lugStart === watchLugWidth) {
                          hasMatching = true;
                          if (variant.available) {
                              hasMatchingInStock = true;
                          }
                      }
                  });
              
                  // ❌ Hide if matching lug width exists but all are OOS
                  if (hasMatching && !hasMatchingInStock) return false;
              
                  // ✅ Show otherwise (includes: no match at all, but still in-stock variants exist)
                  return true;
              });
              
              // Preserve the color dot and get the text content
              let $colourDot = $currentLi.find('.colour-dot');
              let currentText = $currentLi.clone().children().remove().end().text().trim();
              $currentLi.html(`<span class="colour-dot" style="background-color: ${$colourDot.css('background-color')}; width: 12px; height: 12px; border-radius: 50%; display: inline-block; margin-right: 8px;"></span>${currentText} <span class="product-count">(${validProducts.length})</span>`);
              // ❌ Hide li if count is 0
              if (validProducts.length === 0) {
                $currentLi.hide();
              } else {
                $currentLi.show(); // ensure visible if count > 0
              }

              return validProducts.length;
            })();
  
            promises.push(promise);
          }
        });
  
        Promise.all(promises).then(() => {
        //   console.log('✅ All colour product counts updated');
        }).catch(error => {
          console.error('❌ Error updating colour product counts:', error);
        });
      }
    });
}  

// New filter tab functions
changeFilterTab = (element, filterType) => {
    // Remove active class from all filter tab buttons
    $('.filter-tab-button').removeClass('active');
    
    // Add active class to clicked button
    $(element).addClass('active');

    // Hide all filter lists
    $('#colour-filter-list').css('display', 'none');
    $('#strap-filter-list').css('display', 'none');

    // Show the appropriate filter list
    var collection_filter = $('custom-select-collection-filter').find('.custom-select__option.active').attr('filter-collection');
    
    if (filterType === 'material') {
        $('#strap-filter-list').css('display', 'flex');
        var material_filter = $('custom-select-material-filter').find('.custom-select--button .custom-select--text').text();
        loadStraps(collection_filter,material_filter);
        sessionStorage.removeItem('selectedStrapColour');

    } else if (filterType === 'colour') {
        $('#colour-filter-list').css('display', 'flex');
        var colour_filter = $('#colour-filter-list custom-select-colour-filter').find('.custom-select--button .custom-select--text').text();
        loadStrapsByColour(collection_filter,colour_filter);
        sessionStorage.removeItem('selectedStrapMaterial');
    }
    
    // Store the selected filter tab
    sessionStorage.setItem('selectedFilterBy', filterType);
}

changeStrapFilterColour = (element, colour, displayText) => {
    // Remove active class from all colour options
    $('#colour-filter-list .custom-select__option').removeClass('active');
    
    // Add active class to clicked option
    $(element).addClass('active');
    
    // Update the button text with proper capitalization
    const colourDot = $(element).find('.colour-dot');
    const colourDotButton = $('custom-select-colour-filter .colour-dot-button');
    
    // Update the button text and color circle
    $(element).closest('custom-select-colour-filter').find('.custom-select--text').html(
        `<span class="colour-dot-button" style="background-color: ${colourDot.css('background-color')}; width: 12px; height: 12px; border-radius: 50%; display: inline-block; margin-right: 8px;"></span>${displayText}`
    );

    // store the selected filter type and collection filter
    var filter_type = $('custom-select-collection-filter').find('.custom-select__option.active').attr('filter-type');
    var collection_filter = $('custom-select-collection-filter').find('.custom-select__option.active').attr('filter-collection');
    sessionStorage.setItem('selectedFilterType', filter_type);
    sessionStorage.setItem('selectedFilterCollection', collection_filter);

    // Store the selected colour
    sessionStorage.setItem('selectedStrapColour', displayText+','+colour);
    // remove the selected filter by material
    sessionStorage.removeItem('selectedStrapMaterial');
    
    // Apply the colour filter (you'll need to implement the actual filtering logic)
    applyColourFilter(colour);
}

applyColourFilter = (colour) => {
    // Get the current collection filter from the always-visible collection filter
    const collectionFilter = $('#collection-filter-list custom-select-collection-filter').find('.custom-select--list ul .custom-select__option.active').attr('filter-collection');
    
    if (collectionFilter) {
        // Load straps with both collection and colour filter
        loadStrapsByColour(collectionFilter, colour);
    }
}

toggleStrapFilterDropdown = (e) => {
    $('.strap_filter_dropdown').not(e).removeClass('custom-select--active');
    $(e).toggleClass('custom-select--active');
}

toggleStrapFilterMaterialDropdown = (e) => {
    $('.strap_filter_dropdown').not(e).removeClass('custom-select--active');
    $(e).toggleClass('custom-select--active');
    
    // Get the text of the .custom-select--text and convert it to lowercase
    var collection_filter = $('#collection-filter-list custom-select-collection-filter').find('.custom-select--text').text().toLowerCase().trim();
    
    // Set opacity of the entire list to 0
    $(e).find('.custom-select--list').css('opacity', 0);
    
     // Iterate over each .custom-select--list (this is where you want to apply the filter)
     $(e).find('.custom-select--list').each(function() {
        // Get the filter-option-parent attribute and compare it to collection_filter
        var filterOptionParent = $(this).attr('filter-option-parent'); // Get the value of filter-option-parent
        // console.log(filterOptionParent, 'filterOptionParent');
        // If filterOptionParent matches collection_filter, set opacity to 1, else 0
        if (filterOptionParent && filterOptionParent.toLowerCase() === collection_filter) {
            $(this).css('opacity', 1); // Set opacity to 1 if it matches
            // console.log(filterOptionParent, 'trueeeee 111');
        } else {
            $(this).css('opacity', 0); // Otherwise, set opacity to 0
        }
    });
};

toggleStrapColorDropdown = (e) => {
    $('.strap_filter_dropdown').not(e).removeClass('custom-select--active');
    $(e).toggleClass('custom-select--active');
};

changeStrapFilterMaterial = (e, material_filter) => {
    var filter_collection = $('#collection-filter-list custom-select-collection-filter').find('.custom-select--list ul li.active').attr('filter-collection');
    var filter_type = $('#collection-filter-list custom-select-collection-filter').find('.custom-select--list ul li.active').attr('filter-type');
    $('custom-select-material-filter .custom-select--button .custom-select--text').text(material_filter);
   
    $('.section-spacing .watch-preview-img').empty();
    loadStraps(filter_collection,material_filter);

        // store the selected filter type and collection filter
        var filter_type = $('custom-select-collection-filter').find('.custom-select__option.active').attr('filter-type');
        var collection_filter = $('custom-select-collection-filter').find('.custom-select__option.active').attr('filter-collection');
        sessionStorage.setItem('selectedFilterType', filter_type);
        sessionStorage.setItem('selectedFilterCollection', collection_filter);

    // Store the selected filter type
    sessionStorage.setItem('selectedStrapMaterial', material_filter);
    // remove the selected filter by colour
    sessionStorage.removeItem('selectedStrapColour');

}

changeStrapFilterCollection = (e,collection_filter) => {
    $('.section-spacing .watch-preview-img').empty();
    $('#collection-filter-list custom-select-collection-filter ul li').removeClass('active');
    $(e).addClass('active');
    $(e).closest('custom-select-collection-filter').find('.custom-select--button .custom-select--text').text(collection_filter);
    var filter_collection = $(e).attr('filter-collection');
    var filter_type = $(e).attr('filter-type');
    sessionStorage.setItem('selectedFilterType', filter_type);

    $('custom-select-material-filter').find('.custom-select--list').each(function() {
    
        var filterOptionParent = $(this).attr('filter-option-parent'); 
        if (filterOptionParent && filterOptionParent === collection_filter) {
            $(this).addClass('active');

            var material_filter = $(this).find('ul li:first').attr('filter-material');
            $(this).closest('custom-select-material-filter').find('.custom-select--button .custom-select--text').text(material_filter);

            var filter_tab = $('.filter-tab-button.active').attr('filter-type');
            console.log('2 yess',filter_tab);
            // var collection_filter = $('custom-select-collection-filter').find('.custom-select__option.active').attr('filter-collection');
            if (filter_tab === 'material') {
                console.log('3 material');
                var material_filter = $('custom-select-material-filter').find('.custom-select--button .custom-select--text').text();
                loadStraps(filter_collection,material_filter);
                console.log('material',filter_collection,material_filter);
                sessionStorage.setItem('selectedFilterCollection', filter_collection);
                sessionStorage.setItem('selectedStrapMaterial', material_filter);
                sessionStorage.removeItem('selectedStrapColour');
        
            } else if (filter_tab === 'colour') {
                console.log('4 material');
                var colour_filter = $('#colour-filter-list custom-select-colour-filter').find('.custom-select--list ul li.active').attr('filter-colour');
                var colour_filter_text = $('#colour-filter-list custom-select-colour-filter').find('.custom-select--list ul li.active').attr('filter-colour-display');
                loadStrapsByColour(filter_collection,colour_filter);
                console.log('colour',collection_filter,colour_filter);
                sessionStorage.setItem('selectedFilterCollection', filter_collection);
                sessionStorage.setItem('selectedStrapColour', colour_filter_text+','+colour_filter);
                sessionStorage.removeItem('selectedStrapMaterial');
            } 
        } else {
            $(this).removeClass('active');
        }
    }); 

}
changeStrapFilter = (e,type) => {

    if (!$(e).hasClass('active')) {
        $('.section-spacing .watch-preview-img').empty();
        $(e).parent().children().removeClass('active');
        $(e).addClass('active');  
        sessionStorage.setItem('selectedStrapTab', type);
        if (type == 'recommended'){
            var recommendCol = $('.strap-finder-only').attr('watch-recommended-collection');
            var urlObj = new URL(recommendCol);
            var pathSegments = urlObj.pathname.split("/");
            var recommended_col_handle = pathSegments[pathSegments.length - 1];
            hideSubFilterDropdown();
            loadRecommendedStraps(recommended_col_handle);
            // sessionStorage.removeItem('selectedFilterBy');
            // sessionStorage.removeItem('selectedFilterType');
            // sessionStorage.removeItem('selectedFilterCollection');
            // sessionStorage.removeItem('selectedStrapMaterial');
            // sessionStorage.removeItem('selectedStrapColour');
        }else if(type == 'integrated'){
            var recommendCol = $('.strap-finder-only').attr('watch-integrated-collection');
            var urlObj = new URL(recommendCol);
            var pathSegments = urlObj.pathname.split("/");
            var recommended_col_handle = pathSegments[pathSegments.length - 1];
            hideSubFilterDropdown();
            loadRecommendedStraps(recommended_col_handle);
            // sessionStorage.removeItem('selectedFilterBy');
            // sessionStorage.removeItem('selectedFilterType');
            // sessionStorage.removeItem('selectedFilterCollection');
            // sessionStorage.removeItem('selectedStrapMaterial');
            // sessionStorage.removeItem('selectedStrapColour');
        }else if(type == 'all'){
            // var collection_filter = $('custom-select-collection-filter').find('.custom-select__option.active').attr('filter-collection');
            // var material_filter = $('custom-select-material-filter').find('.custom-select--button .custom-select--text').text();
            // // var colour_filter = $('#colour-filter-list custom-select-colour-filter').find('.custom-select--button .custom-select--text').text();
            // // loadStrapsByColour(collection_filter,colour_filter);
            // loadStraps(collection_filter,material_filter);

             // Remove active class from all filter tab buttons
            $('.filter-tab-button').removeClass('active');
            
            // Hide all filter lists
            $('#colour-filter-list').css('display', 'none');
            $('#strap-filter-list').css('display', 'none');

            var selectedFilterBy = sessionStorage.getItem('selectedFilterBy');
            // Show the appropriate filter list
            var collection_filter = $('custom-select-collection-filter').find('.custom-select__option.active').attr('filter-collection');
            
            if (selectedFilterBy === 'colour') {
                $('.filter-tab-button[filter-type="colour"]').addClass('active');
                $('#colour-filter-list').css('display', 'flex');
                var colour_filter = $('#colour-filter-list custom-select-colour-filter').find('.custom-select--button .custom-select--text').text();
                loadStrapsByColour(collection_filter,colour_filter);
                sessionStorage.removeItem('selectedStrapMaterial');

            } else{
                $('.filter-tab-button[filter-type="material"]').addClass('active');
                $('#strap-filter-list').css('display', 'flex');
                var material_filter = $('custom-select-material-filter').find('.custom-select--button .custom-select--text').text();
                loadStraps(collection_filter,material_filter);
                sessionStorage.removeItem('selectedStrapColour');
            }
        }
    }
}

selectMaterial = (e) => {
    var $this = $(e);

    if (!$this.hasClass('active')) {
        $this.parent().children().removeClass('active');
        $this.addClass('active');
    
        var $material = $this.attr('filter-material');
        // console.log($material,'material');
        // Get Flickity instance
        var $carousel = $('.strap-finder__straps-container');
        var flkty = $carousel.data('flickity');
        // console.log(flkty,'flkty')
        // Find the first item with matching strap-type
        var $items = $carousel.find('.columns');
        var targetIndex = -1;
        
        $items.each(function(index) {
            var strap_type = $(this).attr('strap-type').toLowerCase();
            // console.log(strap_type,'strap_type');
            if (strap_type == $material) {
                targetIndex = index;
                // console.log(targetIndex,'targetIndex',$(this).attr('strap-type').toLowerCase());
                return false; // Break the loop once found
            }
        });

        // If found a matching item, slide to it
        if (targetIndex !== -1) {
            flkty.select(targetIndex, true, false); // true = animate, false = no wrap
        }

        $('material-list-option').find('.strap-only-material-list-option.active').children().removeClass('active');
        $('material-list-option').find('.strap-only-material-list-option').removeClass('active');
        $('material-list-option').children(`.strap-only-material-list-option[data-m="${$material}"]`).addClass('active').children().first().addClass('active');
    }
}

selectMaterialOption = (e) => {
    var $this = $(e);
    if (!$this.hasClass('active')) {
        // $('.section-spacing .watch-preview-img').empty();
        $this.parent().children().removeClass('active');
        $this.addClass('active');

        var $option = $this.attr('filter-option');
        // console.log($option,'option');
        // Get Flickity instance
        var $carousel = $('.strap-finder__straps-container');
        var flkty = $carousel.data('flickity');
        // console.log(flkty,'flkty')
        // Find the first item with matching strap-type
        var $items = $carousel.find('.columns');
        var targetIndex = -1;
        
        $items.each(function(index) {
            var strap_type = $(this).attr('strap-material').toLowerCase();
            // console.log(strap_type,'strap_type');
            if (strap_type == $option) {
                targetIndex = index;
                return false; // Break the loop once found
            }
        });

        // If found a matching item, slide to it
        if (targetIndex !== -1) {
            flkty.select(targetIndex, true, false); // true = animate, false = no wrap
        }

    }
}

destroyStrapFlickity = (flckty) =>{
    flckty.flickity();
    flckty.flickity('destroy');
  }


backToCategory = () => {
    $('strap-category').show();
    $('view-colour-button').css('visibility','visible');
}

// $('.watch-preview-download-img.download').click(function(){
//     // console.log('download....');
//     var canvas = document.getElementById('canvas');
//     canvas.width = 920;
//     canvas.height = 2350;
//     var ctx = canvas.getContext('2d');
    
//     ctx.fillStyle = "white";
//     ctx.fillRect(0, 0, canvas.width, canvas.height);

//     var img1 = new Image(); // Watch face
//     var img2 = new Image(); // Top strap
//     var img3 = new Image(); // Bottom strap
    
//     var img1_src = $('.watch-preview-img').find('img').attr('src'); 
//     var img2_src = $('.strap-finder__straps-container .columns.is-selected').find('.sf-top-strap').attr('src'); 
//     var img3_src = $('.strap-finder__straps-container .columns.is-selected').find('.sf-bottom-strap').attr('src'); 
    
//     if (img1_src.includes('?')) img1_src = img1_src.split('?')[0];
//     if (img2_src.includes('?')) img2_src = img2_src.split('?')[0];
//     if (img3_src.includes('?')) img3_src = img3_src.split('?')[0];

//     img1.crossOrigin = "anonymous";
//     img2.crossOrigin = "anonymous";
//     img3.crossOrigin = "anonymous";

//     var count = 0;
    
//     img2.onload = function() {
//         count++;

//         // Top strap dimensions
//         var img2_x = 160; 
//         var img2_y = 500; 
//         var img2_width = 800;
//         var img2_height = 400;

//         ctx.drawImage(img2, img2_x, img2_y, img2_width, img2_height);

//         img3.onload = function() {
//             count++;

//             // Bottom strap dimensions
//             var img3_x = img2_x;
//             var img3_y = img2_y + img2_height;
//             var img3_width = img2_width;
//             var img3_height = 400;

//             ctx.drawImage(img3, img3_x, img3_y, img3_width, img3_height);

//             img1.onload = function() {
//                 count++;

//                 // Watch face matches entire top+bottom strap area
//                 var img1_width = img2_width;
//                 var img1_height = img2_height + img3_height;
//                 var img1_x = img2_x;
//                 var img1_y = img2_y - 10;

//                 ctx.drawImage(img1, img1_x, img1_y, img1_width, img1_height);

//                 // Add text
//                 var strap_text = document.querySelector('.selected-product .title');
//                 var strap = 'Strap: ' + strap_text.textContent;

//                 var watch_text = document.querySelector('.strap-finder__straps-header .so-watch-model');
//                 var watch = 'Watch: ' + watch_text.textContent;

//                 ctx.fillStyle = "black";
//                 ctx.font = "bold 32px Mundo Sans";
//                 ctx.fillText(watch, 40, 260);
//                 ctx.fillText(strap, 40, 296);
                
//                 var bottom_text = canvas.getAttribute('bottom');
//                 ctx.font = "bold 32px Mundo Sans";
//                 ctx.fillText(bottom_text, 170, 2330);
                
//                 var top_text = canvas.getAttribute('top');
//                 ctx.font = "bold 40px Mundo Sans";
//                 ctx.fillText(top_text, 360, 190);
//             };

//             img1.src = img1_src;
//         };

//         img3.src = img3_src;
//     };

//     var checkDone = setInterval(function(){ 
//         if (count == 3) {
//             clearInterval(checkDone);
//             var dataURL = canvas.toDataURL();
//             var title = $('.selected-product .title').text().trim(); 
//             var handle = title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
//             title = 'Delugs Strap Finder - ' + handle;
//             $('.strap-finder__download-button').attr('href', dataURL);
//             $('.strap-finder__download-button').attr('download', title);
//             $('.strap-finder__download-button')[0].click();
//         }
//     }, 50);

//     img2.src = img2_src;
// });

// Function to send pairing data to Supabase via sf.delugs.com
function sendDataToSheety(data) {
    fetch('https://sf.delugs.com/api/pairings', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            email: data.customerEmail || '',
            watch: data.watch || '',
            strap: data.strap || '',
            reference: ''
        })
    })
    .then(function(r) { return r.json(); })
    .then(function(json) { /* saved */ })
    .catch(function(e) { console.error('Pairing save error:', e); });
}

// Function to send download data to webhook for metafield storage
function sendDownloadDataToWebhook(data) {
    const $strapFinderOnly = $('.strap-finder-only');
    const customerID = $strapFinderOnly.attr('customer-id');
    
    if (!customerID) {
        console.log('No customer ID found, skipping webhook call');
        return;
    }
    
    // Get current download history from metafield
    const rawDownloadHistory = $strapFinderOnly.attr('customer-download-history') || '[]';
    let downloadHistory = [];
    
    try {
        downloadHistory = JSON.parse(rawDownloadHistory);
        if (!Array.isArray(downloadHistory)) {
            downloadHistory = [];
        }
    } catch (e) {
        downloadHistory = [];
    }
    
    
    
    // Add new download data without timestamp
    const downloadEntry = {
        customerEmail: data.customerEmail,
        watch: data.watch,
        strap: data.strap
    };
    
    // Add to beginning of array (most recent first)
    downloadHistory.unshift(downloadEntry);
    
    // Limit to last 50 downloads
    if (downloadHistory.length > 50) {
        downloadHistory = downloadHistory.slice(0, 50);
    }
    
    // Update the DOM attribute
    $strapFinderOnly.attr('customer-download-history', JSON.stringify(downloadHistory));
    
    
    // Log the data being sent to webhook
    const webhookData = {
        customer_id: customerID,
        watches: downloadHistory
    };
    
    // Send to webhook
    $.ajax({
        url: "https://webhooks.mechanic.dev/b74889db-c0f3-4c36-a18e-b82c150c7fef",
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify(webhookData),
    }).done(response => {
        // console.log('✅ Download data sent successfully:', response);
    }).fail(error => {
        console.error("❌ Error sending download data:", error);
    });
}

// Function to collect download data
function collectDownloadData() {
    // Get watch information
    const watchBrand = $('.strap-finder-only').attr('watch-brand') || '';
    const watchModel = $('.strap-finder-only').attr('watch-model') || '';
    const watchReference = $('.strap-finder-only').attr('watch-reference') || '';
    
    // Combine watch info into single string
    const watch = `${watchBrand} ${watchModel} ${watchReference}`.trim();
    
    // Get strap information (selected product)
    const strap = $('.selected-product .title').first().text().trim() || '';

    // Get customer email from the strap-finder-only element attribute
    const customerEmail = $('.strap-finder-only').attr('email') || '';
    
    return {
        watch: watch,
        customerEmail: customerEmail,
        strap: strap
    };
}

// Add debounce flag to prevent multiple submissions
let isDownloading = false;

$(".watch-preview-download-img.download").on("click", function () {
    // Prevent multiple clicks while download is in progress
    if (isDownloading) {
        // console.log("Download already in progress, please wait...");
        return;
    }
    
    isDownloading = true;
    const $button = $(this);
    
    // Disable button and show loading state
    $button.prop('disabled', true).addClass('downloading');
    
    const element = document.getElementById("sf-selected-preview");
  
     // ✅ Remove the hidden class to make sure it's rendered properly
     // element.classList.remove("sf-canvas-hide");
   
     // Optional: Add canvas-capture class if needed
     // element.classList.add("canvas-capture");
   
     html2canvas(element, {
        scale: 2,  
         useCORS: true,
         scrollX: 0,
         scrollY: 0
     }).then(canvas => {
       // ✅ Hide again after rendering
     //   element.classList.add("sf-canvas-hide");
         // ⏬ Generate dynamic filename from product title
         var title = $('.selected-product .title').text().trim();
         var handle = title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
         var filename = 'Delugs Strap Finder-' + handle + '.png';
 
         // ⏬ Trigger download
         var link = document.createElement('a');
         link.download = filename;
         link.href = canvas.toDataURL('image/png');
         link.click();
         
         // 📊 Send data to Sheety API and webhook after successful download
         const downloadData = collectDownloadData();
         sendDataToSheety(downloadData);
         sendDownloadDataToWebhook(downloadData);
         
         // Re-enable button after a delay
         setTimeout(() => {
             isDownloading = false;
             $button.prop('disabled', false).removeClass('downloading');
         }, 2000); // 2 second delay
         
     }).catch(err => {
       console.error("Download failed:", err);
       // Re-enable button on error
       isDownloading = false;
       $button.prop('disabled', false).removeClass('downloading');
     //   element.classList.add("sf-canvas-hide");
     });
});


toggleStrapTooltip = () => {
    $('custom-select-strap-type').css('overflow-x', 'unset');
}

toggleTooltip = (element) => {
    const $tooltipBox = $(element).siblings('.sf-tooltip-box');
    if ($tooltipBox.length) {
        $tooltipBox.toggle();
    }
}


  

  